/* LES STATUTS, EN FRANCAIS PLUTOT QU'EN CONSTANTES.

   Le tableau des paiements du detail d'un lot affichait « REGLEMENT_TECHNIQUE_VALIDE ».
   Sa table de libelles n'en connaissait que quatre - EMIS, VALIDE, PAYE, ANNULE - alors
   que `StatutPaiement` en compte cinq, dont les deux etapes du circuit comptable. Celles
   qu'on voit le plus souvent, donc, etaient justement les deux qui manquaient. Et
   « VALIDE » n'existe dans aucun des deux enums : c'etait une entree pour un statut qui
   n'a jamais ete envoye.

   `OrdreDeDepenseLotGlobal` imprimait le statut brut sur le papier.

   Les libelles vivaient en double, dans la liste des lots et dans le detail d'un lot. Ils
   sont ici, une fois, et les deux ecrans y puisent.

   LES COULEURS ET LES ICONES RESTENT DANS LEURS ECRANS : ce sont des choix d'affichage
   portes par du JSX, et un document imprime n'en a pas l'usage. Seuls les mots sont
   partages.

   LES MOTS SUIVENT LA LANGUE DE L'ECRAN (FR / EN). Ils vivent dans
   locales/<langue>/reglementsExperts.json, sous `statuts`, et se lisent au moment ou on
   consulte la table : des chaines posees au chargement du module garderaient la langue
   du demarrage. `Object.keys` et `TABLE[code]` marchent comme avant. Le document
   imprime, qui reste en francais, demande sa langue : `libelleStatutLot(code, 'fr')`. */
import i18n from '../../i18n';

/** Le libelle d'un code connu de `codes`, dans la langue de l'ecran ou `lng` ; `undefined` sinon. */
const traduire = (famille, codes, code, lng) => (codes.includes(code)
  ? i18n.t(`reglementsExperts:statuts.${famille}.${code}`, { lng })
  : undefined);

/** Une table code → libelle dont chaque entree se traduit a la lecture. */
const tableTraduite = (famille, codes) => codes.reduce((table, code) => Object.defineProperty(
  table, code, { get: () => traduire(famille, codes, code), enumerable: true },
), {});

const CODES_STATUT_LOT = [
  'EMIS', 'REGLEMENT_TECHNIQUE_VALIDE', 'REGLEMENT_COMPTABLE_VALIDE',
  'PAYE', 'PARTIELLEMENT_ANNULE', 'ANNULE',
];

const CODES_STATUT_PAIEMENT = [
  'EMIS', 'REGLEMENT_TECHNIQUE_VALIDE', 'REGLEMENT_COMPTABLE_VALIDE', 'PAYE', 'ANNULE',
];

/** `StatutLotReglement` — les six valeurs du serveur. */
export const LIBELLE_STATUT_LOT = tableTraduite('lot', CODES_STATUT_LOT);

/** `StatutPaiement` — les cinq valeurs du serveur, dont les deux qui manquaient. */
export const LIBELLE_STATUT_PAIEMENT = tableTraduite('paiement', CODES_STATUT_PAIEMENT);

/**
 * Le filet de securite : un code inconnu se lit quand meme.
 *
 * <p>« REGLEMENT_TECHNIQUE_VALIDE » devient « Reglement technique valide ». Sans accents -
 * on ne peut pas les deviner - et c'est pourquoi ce n'est qu'un filet : les deux tables
 * ci-dessus portent les vrais libelles. Mais le jour ou le serveur ajoute un statut, il
 * s'affichera en mots plutot qu'en constante, et personne n'aura a s'en apercevoir par
 * une capture d'ecran.
 */
export function humaniserCode(code) {
  if (!code) return '—';
  const mots = String(code).replace(/_+/g, ' ').trim().toLowerCase();
  return mots.charAt(0).toUpperCase() + mots.slice(1);
}

/** Le libelle du statut d'un lot. `lng` : une langue imposee (un document), sinon celle de l'ecran. */
export function libelleStatutLot(code, lng) {
  return traduire('lot', CODES_STATUT_LOT, code, lng) || humaniserCode(code);
}

/** Le libelle du statut d'un paiement. `lng` : une langue imposee, sinon celle de l'ecran. */
export function libelleStatutPaiement(code, lng) {
  return traduire('paiement', CODES_STATUT_PAIEMENT, code, lng) || humaniserCode(code);
}
